
const state = {
  user: null,
  userToken: null,
  loading: false,
  loginAt: null,
  lastActive: null,
  menus: null,
  paths: null,
  showToast: {},
  defaultCompany: {},
  allCompanies: {},
  isAuthenticated: false
};

const getters = {
  isAuthenticated: (state) => state.isAuthenticated ,
  userData: (state) => state.user,
  userToken : (state) => state.userToken,
  loginAt : (state) => state.loginAt,
  lastActive: (state) => state.lastActive,
  menus : (state) => state.menus,
  paths : (state) => state.paths,
  getLoading : (state) => state.loading,
  showToast: (state) => state.showToast,
  defaultCompany: (state) => state.defaultCompany,
  allCompanies: (state) => state.allCompanies
};

const actions = {
  async showLoading({commit}){
    commit("showLoading");
  },

  async hideLoading({commit}){
    commit("hideLoading");
  },

  async LogOut({commit}){
    commit('logout');
  },

  async setDefaultCompany({commit},company){
    commit('setCompany',company);
  }
};

const mutations = {
  setUser(state, userdata) {
    state.user = userdata.data;
    state.menus = userdata.menu;
    state.userToken = userdata.token;
    state.loginAt = new Date();
    state.lastActive = new Date();
    fetch('layout/leftmenu/paths.json').then(res => res.json()).then(d => state.paths = d)
  },

  setCompany(state,company){
    state.defaultCompany = company
  },

  showLoading(state){
    state.loading = true;
  },

  hideLoading(state){
    state.loading = false;
  },

  logout(state) {
    state.user = null;
    state.menus = null;
    state.userToken = null;
    state.paths = null;
    state.defaultCompany = {};
    state.allCompanies = {};
    state.loginAt = null;
    state.lastActive = null;
  },

  logoutIsAuth401(state) {
    state.user = null;
    state.menu = null;
    state.userToken = null;
    state.paths = null;
    state.defaultCompany = {};
    state.isAuthenticated = false;
    state.allCompanies = {};
    state.loginAt = null;
    state.lastActive = null;
  },

  logoutIsAuth(state,status){
    state.isAuthenticated = status;
  },

  setShowToast(state,data){
    state.showToast = {
      severity : data[0],
      title: data[1],
      message: data[2]
    }
  },

  lastActive(state,data){
    state.lastActive = data
  },

  setCompanyList(state, data){
    state.allCompanies = data
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};